export default {
  'variant-1': `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 733 405">
      <path class="animate" stroke="#B5A3FF" stroke-width="6" d="M440 107.143V-78H3v185.143h437Zm0 0V246m0 0h212c43.078 0 78 34.922 78 78s-34.922 78-78 78H440V246Z"/>
    </svg>`,
  'variant-2': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 408 464" fill="none">
      <path class="animate" d="M186.92 464V232.251V3H3V401.568H342.568C377.048 401.568 405 429.52 405 464V464" stroke="#B5A3FF" stroke-width="6"/>
    </svg>`,
  'variant-3': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1066 402" fill="none">
    <path class="animate" d="M1098 165.861L151.155 165.861C69.3193 165.861 3 100.761 3 20.4303C3 -59.9005 69.3193 -125 151.155 -125L600.206 -125L600.206 399L1098 399" stroke="#B5A3FF" stroke-width="6" stroke-miterlimit="10"/>
  </svg>`,
  'variant-4': `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 515 354">
    <path class="animate" stroke="#B5A3FF" stroke-miterlimit="10" stroke-width="6" d="M0 196.476h603v-372.558C606-243.978 551.926-299 485.2-299c-66.727 0-120.801 55.022-120.801 122.918V378H3V196.476Z"/>
  </svg>`,
  'variant-5': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 422 337" fill="none">
    <path class="animate" d="M3 337V285.77H419V3H221.262V337" stroke="#B5A2FF" stroke-width="6"/>
  </svg>`,
};
